module.exports = __webpack_public_path__ + "static/media/cross.83c6ace7.svg";